<ng-template [ngIf]="active">
    <ng-content></ng-content>
</ng-template>
